import _ from 'lodash';

import splitUrlPiece from './splitUrlPiece';

const splitUrl = _.partial(splitUrlPiece, '?');

export default splitUrl;
